export default __webpack_public_path__ + "static/media/fios-03.01122115.jpg";